/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_SUB_BENEFIT,
  RESET_BENEFIT_OTHER,
  RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT,
  RESET_BURIAL,
  RESET_REPATRIATION,
  RESET_PERSONAL_LIABILITY,
  RESET_PERSONAL_ACCIDENT,
  RESET_LOSS_OF_INCOME,
  RESET_TOTAL_PERMANENT_DISABLEMENT,
  RESET_LOSS_OF_LIFE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetSubBenefit() {
  return {
    type: RESET_SUB_BENEFIT,
  };
}

export function resetBenefitOther() {
  return {
    type: RESET_BENEFIT_OTHER,
  };
}

export function resetFormAccidentalDeathAndDismemberment() {
  return {
    type: RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT,
  };
}

export function resetFormBurialExpenses() {
  return {
    type: RESET_BURIAL,
  };
}

export function resetFormRepatriationExpenses() {
  return {
    type: RESET_REPATRIATION,
  };
}

export function handleOnDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function resetFormPersonalLiability() {
  return {
    type: RESET_PERSONAL_LIABILITY,
  };
}

export function resetFormPersonalAccident() {
  return {
    type: RESET_PERSONAL_ACCIDENT,
  };
}

export function resetFormLossOfIncome() {
  return {
    type: RESET_LOSS_OF_INCOME,
  };
}

export function resetFormTotalPermanentDisablement() {
  return {
    type: RESET_TOTAL_PERMANENT_DISABLEMENT,
  };
}

export function resetFormLossOfLife() {
  return {
    type: RESET_LOSS_OF_LIFE,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/actions.js